import { getRandomBetween } from "../utils";

export default function createMaryEllenQueen() {
  const pattern = getRandomBetween(0.6, 0.9);

  const layingVigor = getRandomBetween(0.5, 0.9);
  const honey = getRandomBetween(0.4, 0.8);
  const diseaseResistance = getRandomBetween(0.7, 0.9);
  const swarmTendency = getRandomBetween(0.1, 0.6);
  const aggression = getRandomBetween(0.4, 0.8);
  const miteResistance = getRandomBetween(0.8, 0.99);
  const overWinter = getRandomBetween(0.6, 0.9);

  let queenStats = {
    haveQueen: true,
    layingVigor: layingVigor,
    pattern: pattern,
    honey: honey,
    diseaseResistance: diseaseResistance,
    swarmTendency: swarmTendency,
    droneTendency: 0.05,
    aggression: aggression,
    virgin: false,
    laying: true,
    miteResistance: miteResistance,
    overwinter: overWinter,
    breed: "Mary Ellen",
    birth: new Date().getTime(),
  };
  return queenStats;
}
